import styled from 'styled-components';
import { rem } from 'polished';

import mediaqueries from '../../../../config/themes/variables/mediaqueries';
import BoxInside from '../../../core/BoxInside';
import Button from '../../../core/Buttons';
import Input from '../../../core/Input';
import { TabsHorizontal } from '../../../core/TabsHorizontal';

const StyledBoxInside = styled(BoxInside)`
  padding-bottom: 0;
  padding-left: 0;
  padding-right: 0;
`;

const StyledWrapperRow = styled.div`
  padding-top: ${rem('30px')};
  padding-bottom: ${rem('30px')};
  background-color: ${props => props.theme.colors.grayLightest};
  margin-bottom: ${rem('20px')};
`;

const StyledNewImportant = styled.div`
  ${mediaqueries.lessThan('mobile')`
    margin-bottom: ${rem('25px')};
  `};
  ${mediaqueries.greaterThan('desktop')`
    grid-column: 1 / 3;
    grid-row: 1;
    -ms-grid-row: 1;
    -ms-grid-column-span: 3; 
  `};
  padding: 0;
  background-color: ${props => props.theme.colors.light};
  grid-column: 1 / 3;
  grid-row: 2;
  -ms-grid-column: 1 / 3;
  -ms-grid-row: 2;
  margin-top: 0;
  max-width: 1100px;
  margin: 0 auto;
`;

const StyledTitleDepartment = styled.h2`
  font-size: ${rem('20px')};
  font-family: ${props => props.theme.fonts.bold};
  text-transform: uppercase;
  margin-top: ${rem('30px')};

  ${mediaqueries.greaterThan('desktop')`
    font-size: ${rem('28px')};
    margin: ${rem('30px')} ${rem('20px')} ${rem('20px')};
    margin-left: 0;
    padding-left: 0;
  `};
`;

const StyledDocumentsWrapper = styled.div`
  padding-bottom: ${rem('80px')};
  margin: 0 ${rem('18px')};
  margin-top: ${rem('30px')};
  ${mediaqueries.greaterThan('tablet')`
     margin: ${rem('30px')} ${rem('25px')} 0 ${rem('25px')} ;
  `};
  ${mediaqueries.greaterThan('desktop')`
    margin: ${rem('30px')} auto 0 auto;
    max-width: ${rem('1232px')};
    padding-bottom: 0;    
  `};
`;

const StyledFilter = styled.div`
  display: flex;
  justify-content: flex-end;
  position: absolute;
  top: ${rem('10px')};
  right: 0;
  ${mediaqueries.greaterThan('tablet')`
    top: 0;
  `};
`;

const StyledButton = styled.button`
  background: none;
  border: none;
  margin-left: ${rem('10px')};
  margin-top: ${rem('-5px')};

  &:hover {
    & > svg {
      fill: ${props => props.theme.colors.primary};
    }
  }
`;

const StyledButtonPlus = styled(Button)`
  width: ${rem('24px')};
  height: ${rem('24px')};
  padding: 0;
  position: absolute;
  bottom: ${rem('34px')};
  right: 0;
  margin-left: ${rem('10px')};
  margin-right: ${rem('10px')};
  position: static;
  margin-bottom: 2px;
  background-color: #f95752;

  & > svg {
    position: relative;
    left: ${rem('4px')};
  }

  ${mediaqueries.lessThan('tablet')`
    width: ${rem('16px')};
    height: ${rem('16px')};
  `};
`;

const StyledButtonUp = styled(StyledButton)`
  transform: rotate(-90deg);
  & > svg {
    fill: ${props =>
      props.active ? props.theme.colors.primary : props.theme.colors.gray};
  }
`;

const StyledButtonDown = styled(StyledButton)`
  transform: rotate(90deg);
  & > svg {
    fill: ${props =>
      props.active ? props.theme.colors.primary : props.theme.colors.gray};
  }
`;

const StyledFilterText = styled.p`
  display: none;
  font-family: ${props => props.theme.fonts.bookItalic};
  font-size: ${rem('14px')};
  ${mediaqueries.greaterThan('tablet')`
    display: block;
  `};
`;

const StyledTabsHorizontal = styled(TabsHorizontal)`
  margin-bottom: ${rem('20px')};
  margin-top: ${rem('35px')};
  ${mediaqueries.greaterThan('desktop')`
    border-bottom: ${rem('2px')} solid ${props => props.theme.colors.grayLight};
  `};
`;

const StyledWrapperFlex = styled.div`
  position: relative;
`;

const StyledWrapperGroupInput = styled.div`
  display: flex;
  flex-wrap: wrap;
`;

const StyledLabel = styled.p`
  font-family: ${props => props.theme.fonts.bookItalic};
  font-size: ${rem('14px')};
`;

const StyledInput = styled(Input)`
  padding: ${rem('11px')} ${rem('18px')} ${rem('11px')} ${rem('8px')};
  width: 80%;
`;

const StyledGroupInput = styled(Input)`
  position: relative;
  padding: ${rem('11px')} ${rem('18px')} ${rem('11px')} ${rem('8px')};
  width: ${rem('140px')};
`;

const StyledFileInput = styled(Input)`
  position: relative;
  padding: ${rem('11px')} ${rem('18px')} ${rem('11px')} ${rem('8px')};
  width: 40%;
`;

const StyledButtonPencil = styled(Button)`
  width: ${rem('34px')};
  height: ${rem('34px')};
  padding: 0;
  margin-top: ${rem('14px')};
  position: static;
  background-color: #ffffff;

  & > svg {
    position: relative;
    left: ${rem('4px')};
  }
  &:hover,
  &:active {
    background-color: #ffffff;
  }
`;

const StyledWrapperButtons = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-top: ${rem('40px')};
  //justify-content: space-between;
  gap: 100px;
`;

export {
  StyledBoxInside,
  StyledWrapperRow,
  StyledNewImportant,
  StyledTitleDepartment,
  StyledDocumentsWrapper,
  StyledFilter,
  StyledButton,
  StyledButtonPlus,
  StyledButtonUp,
  StyledButtonDown,
  StyledFilterText,
  StyledTabsHorizontal,
  StyledWrapperFlex,
  StyledWrapperGroupInput,
  StyledLabel,
  StyledInput,
  StyledGroupInput,
  StyledFileInput,
  StyledButtonPencil,
  StyledWrapperButtons
};
